/// <amd-module name="Artifacts/Root/containers/FeedMessageBar" />

import { RootActions } from "Artifacts/Root/redux/Actions";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { IFeed } from "Artifacts/Root/types";
import { FeedMessage, MessageType } from "Artifacts/Root/types/AzureArtifacts";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "VSSUI/Link";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

const Actions = {
  hideFeedMessage: RootActions.hideFeedMessage,
  loadFeedMessage: RootActions.loadFeedMessages,
};

const FeedMessageBar: React.FC<IFeedMessageBarMapStateToProps & typeof Actions> = ({
  feedMessages,
  hideFeedMessage,
  loadFeedMessage,
  feed,
}) => {
  const [feedId, setFeedId] = useState<string | undefined>();

  useEffect(() => {
    if (feed && !feed.isDeleted && feedId !== feed.id) {
      loadFeedMessage(feed);
      setFeedId(feed.id);
    }
  }, [feed, feedId, loadFeedMessage]);

  if (feed?.id == null || feedMessages == null || feedMessages.length < 1) {
    return null;
  }

  return (
    <div className="flex flex-column feed-message-bar">
      {feedMessages.map((feedMessage, index) => {
        return (
          <MessageCard
            key={feedMessage.id}
            severity={getMessageType(feedMessage.messageType)}
            onDismiss={() => hideFeedMessage(index)}
          >
            {feedMessage.message}
            {feedMessage.linkText && feedMessage.linkUrl && (
              <Link className="feed-message-link" href={feedMessage.linkUrl} underline>
                {feedMessage.linkText}
              </Link>
            )}
          </MessageCard>
        );
      })}
    </div>
  );
};

function getMessageType(type: MessageType): MessageCardSeverity {
  switch (type) {
    case MessageType.Error:
      return MessageCardSeverity.Error;
    case MessageType.Warning:
      return MessageCardSeverity.Warning;
    default:
      return MessageCardSeverity.Info;
  }
}

interface IFeedMessageBarMapStateToProps {
  feedMessages?: FeedMessage[];
  feed?: IFeed;
}

const mapStateToProps = (state: IRootModuleState): IFeedMessageBarMapStateToProps => {
  return {
    feedMessages: state.rootState.feed?.feedMessages,
    feed: state.rootState.feed,
  };
};

const ConnectedFeedMessageBar = connect(mapStateToProps, Actions)(FeedMessageBar);

export { ConnectedFeedMessageBar as FeedMessageBar };
